export const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // +1 sepse muajt fillojnë nga 0
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
};